import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import about1 from "../../assets/Images/Home/KGM-65.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function About() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleKnowMore = () => {
    navigate("/about");
  };

  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-right-black border-bottom-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "45%",
            }}
          ></div>
        )}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "45%",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0">ABOUT.</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>

      {/* Main Content Row */}
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          className={`image-container border-bottom-black ${
            !isMobile && "border-right-black"
          }`}
          style={{
            width: isMobile ? "100%" : "45%",
            padding: "0",
            overflow: "hidden",
            minHeight: isMobile ? "400px" : "600px",
            position: "relative",
          }}
        >
          <img
            className="image-cover-full-responsive"
            src={about1}
            alt="Profile 1"
            style={{
              transition: "transform 0.5s ease-in-out",
              transform: isHovered ? "scale(1.05)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </div>

        {/* Text Column */}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "45%",
            padding: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg accent-text">Design is a living canvas,</p>
            <p className="body-lg">
              reflecting the soul and stories of those who inhabit a space.
            </p>
            <p className="body-lg">
              Kritika’s approach is defined by a seamless balance between
              functionality and aesthetics. She views design as a collaborative
              journey, where understanding lifestyles, aspirations, and personal
              narratives is key to creating spaces that resonate with
              individuality. Her perspective is holistic—integrating elements of
              art, culture, and craftsmanship to blend timeless elegance with
              modern sensibilities. With meticulous attention to detail and a
              talent for curating meaningful décor, her work transforms spaces
              into environments that inspire, comfort, and elevate.
            </p>
          </div>
          <div
            style={{
              padding: isMobile ? "20px 40px" : "0 80px 40px",
            }}
          >
            <Button
              className="rounded-0 text-uppercase"
              variant="outline-dark"
              style={{
                fontSize: isMobile ? "18px" : "28px",
                fontFamily: "BodoniModa_18pt",
                width: isMobile ? "100%" : "75%",
                transition: "all 0.3s ease-in-out",
                position: "relative",
                overflow: "hidden",
                zIndex: 1,
              }}
              onClick={handleKnowMore}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#000";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#000";
              }}
            >
              Know More
            </Button>
          </div>
        </div>

        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
